export default __webpack_public_path__ + "static/l2savings-e40e2de648b5c110ada1a0e1b44e3ee5.jpg";